var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 10.0003C12.3011 10.0003 14.1666 8.13485 14.1666 5.83366C14.1666 3.53247 12.3011 1.66699 9.99992 1.66699C7.69873 1.66699 5.83325 3.53247 5.83325 5.83366C5.83325 8.13485 7.69873 10.0003 9.99992 10.0003Z",
    stroke: "#5C5E64",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0085 13.1172L13.0585 16.0672C12.9418 16.1839 12.8335 16.4005 12.8085 16.5588L12.6502 17.6838C12.5919 18.0922 12.8752 18.3755 13.2835 18.3172L14.4085 18.1588C14.5668 18.1338 14.7919 18.0255 14.9002 17.9088L17.8502 14.9589C18.3585 14.4505 18.6002 13.8588 17.8502 13.1088C17.1085 12.3672 16.5169 12.6088 16.0085 13.1172Z",
    stroke: "#5C5E64",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5837 13.542C15.8337 14.442 16.5337 15.142 17.4337 15.392",
    stroke: "#5C5E64",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84155 18.3333C2.84155 15.1083 6.04991 12.5 9.99991 12.5C10.8666 12.5 11.6999 12.625 12.4749 12.8583",
    stroke: "#5C5E64",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSettings);
export default __webpack_public_path__ + "static/media/profile-settings.d394e0675c831e4497ec152bd47596a9.svg";
export { ForwardRef as ReactComponent };